
export function camelToDashes (str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function dashesToCamel (str) {
  return str.replace(/-([a-z])/g, g => g[1].toUpperCase());
}

export function camelToConstCase(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
}


export function escapeRegExp (string){
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export function escapeHTML(unsafe) {
  return unsafe
           .replace(/&/g, "&amp;")
           .replace(/</g, "&lt;")
           .replace(/>/g, "&gt;")
           .replace(/"/g, "&quot;")
           .replace(/'/g, "&#039;");
}

function _re (flags, templateString, ...values) {
  return new RegExp(String.raw(templateString, ...values.map(escapeRegExp)), flags);
}


/**
 * ES6 template string tag that generates a RegExp with substitution variables.
 * @return {RegExp}
 */
export function re(templateString, ...values) {
  return _re('', templateString, ...values);
}
const flags = 'g i m u y gi gm gu gy im iu iy mu my uy gim giu giy gmu gmy guy imu imy iuy muy gimu gimy giuy gmuy imuy gimuy'.split(' ')

for (let flag of flags) {
  re[flag] = function(templateString, ...values) {
    return _re(flag, templateString, ...values);
  }
}

export function randomString(length=16, chars='0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }

  return result;
}


export function replaceTagAttribute(srcString, tag, attribute, replacer) {
  let reTagPattern = re.g`<${tag}(?:(?:\s+(${attribute})(?:\s*=\s*(".*?"|'.*?'|[\^'">\s]+))?)+\s*|\s*)\/?>`
  return srcString.replace(reTagPattern,
    (match, attr, value) => match.replace(value, replacer))
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/string.js